import "core-js/modules/web.dom.iterable";
import { getOverlapGroupHandler } from "./common";
var FULL_WIDTH = 100;
export var column = function column(events, firstWeekday, overlapThreshold) {
  var handler = getOverlapGroupHandler(firstWeekday);
  return function (day, dayEvents, timed, reset) {
    var visuals = handler.getVisuals(day, dayEvents, timed, reset);

    if (timed) {
      visuals.forEach(function (visual) {
        visual.left = visual.column * FULL_WIDTH / visual.columnCount;
        visual.width = FULL_WIDTH / visual.columnCount;
      });
    }

    return visuals;
  };
};